module.exports = __webpack_public_path__ + "static/media/pencil-min.46513774.png";